import React from 'react';
import { COMPANY } from '../../../content/staticAssets';

const partners = [
  {
    name: 'SOF Financial Group',
    src: COMPANY.sofIcon,
    frameClass: 'h-20 w-20 p-1',
    body: 'Strategic financial advisory partnership providing capital solutions, investment expertise, and financial guidance to support growth initiatives.',
  },
  {
    name: 'Distrocode',
    src: COMPANY.distrocode,
    frameClass: 'h-20 w-20 p-1',
    body: 'Technology innovation partnership specializing in advanced digital solutions and next-generation development frameworks.',
  },
];

const CompanyOwnership = () => {
  return (
    <section className="section">
      <div className="container-x min-w-0">
        <div className="mx-auto max-w-3xl text-center">
          <p className="eyebrow">Parent and partners</p>
          <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl lg:text-[2.75rem]">
            Backed by stable ownership and strategic partners.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">
            MyOrgLab operates with the governance, financial oversight, and
            strategic direction of an enterprise parent and a focused set of
            partners that extend our reach.
          </p>
        </div>

        <div className="relative mt-12 overflow-hidden rounded-2xl border border-[#00123F]/15 bg-[#00123F] p-8 text-white shadow-lg sm:p-10 lg:p-12">
          <div
            className="pointer-events-none absolute inset-0 opacity-80"
            aria-hidden="true"
            style={{
              background:
                'radial-gradient(42rem 22rem at 8% -10%, rgba(0,180,254,0.28), transparent 62%), radial-gradient(28rem 18rem at 100% 110%, rgba(25,227,242,0.18), transparent 58%)',
            }}
          />
          <div className="relative grid items-center gap-8 lg:grid-cols-[auto_1fr] lg:gap-12">
            <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-2xl bg-white p-3 shadow-md sm:h-28 sm:w-28">
              <img
                src={COMPANY.monroeIcon}
                alt="Monroe Acquisitions LLC"
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#19E3F2]">
                Parent company
              </p>
              <h3
                className="mt-2 font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl"
                style={{ color: '#FFFFFF' }}
              >
                Monroe Acquisitions LLC
              </h3>
              <p className="mt-3 max-w-2xl text-base leading-7 text-white/80">
                Provides enterprise-grade governance, financial oversight, and
                long-term strategic direction across the MyOrgLab platform.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          {partners.map((partner) => (
            <article
              key={partner.name}
              className="card min-w-0 overflow-hidden p-0"
            >
              <div
                className="h-1.5 w-full"
                style={{ background: 'linear-gradient(90deg, #00B4FE 0%, #19E3F2 100%)' }}
                aria-hidden="true"
              />
              <div className="p-8">
                <p className="eyebrow">Strategic partner</p>
                <div className="mt-5 flex items-start gap-4">
                  <div className={`flex ${partner.frameClass} shrink-0 items-center justify-center overflow-hidden rounded-xl border border-ink-200 bg-surface-subtle`}>
                    <img
                      src={partner.src}
                      alt={partner.name}
                      className="h-full w-full object-contain"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-display text-xl font-semibold text-ink-900">
                      {partner.name}
                    </h3>
                    <p className="mt-3 text-ink-600 leading-7">{partner.body}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyOwnership;

// Archived alternate layout — keep for a later company-page pass.
// eslint-disable-next-line no-unused-vars
const _Legacy = () => {
  return (
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 mt-8 mb-16 hidden">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Corporate Structure & Partnerships</h2>
        <div className="w-24 h-1 bg-logo-blue mx-auto mb-6"></div>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Backed by strategic leadership and trusted partnerships that drive innovation and excellence.
        </p>
      </div>

      <div className="bg-gradient-to-br from-logo-light-blue/20 via-white to-logo-blue/10 rounded-2xl shadow-xl p-10 mb-10 border border-logo-blue/20 max-w-4xl mx-auto relative overflow-hidden">
        <div className="relative z-10 text-center">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-xl shadow-lg mb-6 border-4 border-logo-blue/20">
            <img
              src={COMPANY.monroeIcon}
              alt="Monroe Acquisitions LLC Logo"
              className="w-18 h-18 rounded-lg object-contain"
            />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Parent Company</h3>
          <p className="text-xl font-semibold text-logo-blue mb-4">Monroe Acquisitions LLC</p>
          <p className="text-gray-700 leading-relaxed max-w-3xl mx-auto">
            <span className="font-semibold text-logo-dark-blue">MyOrgLab</span> operates as a strategic subsidiary of
            <span className="font-semibold text-logo-blue"> Monroe Acquisitions LLC</span>,
            providing enterprise-grade governance, financial oversight, and strategic direction.
          </p>
        </div>
      </div>
    </div>
  );
};
